import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const fundDisbursement = {
  namespaced: true,

  state: () => ({
    allFundDisbursements: [],
    approvedFundDisbursements: {
      data: [],
      totalRecords: 0
    },
    disapprovedFundDisbursements: {
      data: [],
      totalRecords: 0
    },
    pendingFundDisbursements: {
      data: [],
      totalRecords: 0
    },
    deletedFundDisbursements: {
      data: [],
      totalRecords: 0
    },
    fundDisbursementBeneficiaries: {
      data: [],
      totalRecords: 0
    },
    fundDisbursementRepostAwaitingApproval: {
      data: [],
      totalRecords: 0
    },
    fundDisbursementRepostApproved: {
      data: [],
      totalRecords: 0
    },
    fundDisbursementRepostDisapproved: {
      data: [],
      totalRecords: 0
    }
  }),

  getters: {
    _allFundDisbursements: state => state.allFundDisbursements,
    _approvedFundDisbursements: state => state.approvedFundDisbursements,
    _disapprovedFundDisbursements: state => state.disapprovedFundDisbursements,
    _pendingFundDisbursements: state => state.pendingFundDisbursements,
    _deletedFundDisbursements: state => state.deletedFundDisbursements,
    _fundDisbursementBeneficiaries: state => state.fundDisbursementBeneficiaries,
    _fundDisbursementRepostAwaitingApproval: state => state.fundDisbursementRepostAwaitingApproval,
    _fundDisbursementRepostApproved: state => state.fundDisbursementRepostApproved,
    _fundDisbursementRepostDisapproved: state => state.fundDisbursementRepostDisapproved
  },

  mutations: {
    ALL_FUND_DISBURSEMENTS (state, data) {
      state.allFundDisbursements = data
    },
    APPROVED_FUND_DISBURSEMENTS (state, { totalRecords, data }) {
      state.approvedFundDisbursements.totalRecords = parseInt(totalRecords)
      state.approvedFundDisbursements.data = data
    },
    DISAPPROVED_FUND_DISBURSEMENTS (state, { totalRecords, data }) {
      state.disapprovedFundDisbursements.totalRecords = parseInt(totalRecords)
      state.disapprovedFundDisbursements.data = data
    },
    PENDING_FUND_DISBURSEMENTS (state, { totalRecords, data }) {
      state.pendingFundDisbursements.totalRecords = parseInt(totalRecords)
      state.pendingFundDisbursements.data = data
    },
    DELETED_FUND_DISBURSEMENTS (state, { totalRecords, data }) {
      state.deletedFundDisbursements.totalRecords = parseInt(totalRecords)
      state.deletedFundDisbursements.data = data
    },
    FUND_DISBURSEMENT_SUMMARY (state, { totalRecords, data }) {
      state.fundDisbursementBeneficiaries.totalRecords = parseInt(totalRecords)
      state.fundDisbursementBeneficiaries.data = data
    },
    FUND_DISBURSEMENT_BENEFICIARIES (state, { totalRecords, data }) {
      state.fundDisbursementBeneficiaries.totalRecords = parseInt(totalRecords)
      state.fundDisbursementBeneficiaries.data = data
    },
    FUND_DISBURSEMENT_REPOST_AWAITING_APPROVAL (state, { totalRecords, data }) {
      state.fundDisbursementRepostAwaitingApproval.totalRecords = parseInt(totalRecords)
      state.fundDisbursementRepostAwaitingApproval.data = data
    },
    FUND_DISBURSEMENT_REPOST_APPROVED (state, { totalRecords, data }) {
      state.fundDisbursementRepostApproved.totalRecords = parseInt(totalRecords)
      state.fundDisbursementRepostApproved.data = data
    },
    FUND_DISBURSEMENT_REPOST_DISAPPROVED (state, { totalRecords, data }) {
      state.fundDisbursementRepostDisapproved.totalRecords = parseInt(totalRecords)
      state.fundDisbursementRepostDisapproved.data = data
    }
  },

  actions: {
    CreateSingleFundDisbursement ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/FundDisbursement/CreateFundDisbursementSingleWeb', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    CreateBulkFundDisbursement ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/FundDisbursement/CreateFundDisbursementWeb', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GenerateFundDisbursementAprovalToken ({ rootState, dispatch }, { headers, fundDisbursementId }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post(`/FundDisbursement/GenerateFundDisbursementAprovalToken?FundDisbursementId=${fundDisbursementId}`, null, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 1000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    ApproveFundDisbursement ({ rootState, dispatch }, { nextApprovalUserId, token, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true

        api.post(`/FundDisbursement/ApproveFundDisbursement?Token=${token}&NextApprovalUserId=${nextApprovalUserId}`, null, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
              rootState.loading = false
            }
          })
      })
    },
    DisapproveFundDisbursement ({ rootState, dispatch }, { fundDisbursementId, comment, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post(`/FundDisbursement/DisapproveFundDisbursement?FundDisbursementId=${fundDisbursementId}&Comment=${comment}`, null, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DeleteFundDisbursement ({ rootState, dispatch }, { fundDisbursementId, comment, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post(`/FundDisbursement/DeleteFundDisbursement?FundDisbursementId=${fundDisbursementId}&Comment=${comment}`, null, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DownloadFundDisbursementBeneficiaries ({ rootState, dispatch }, { fundDisbursementId, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api({
          url: `/FundDisbursement/DownloadFundDisbursementBeneficiaries?FundDisbursementId=${fundDisbursementId}`,
          method: 'GET',
          responseType: 'blob', // file type to be returned
          headers: config.headers
        })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    // ADMIN
    RepostFundDisbursement ({ rootState, dispatch }, { fundDisbursementId, comment, config }) {
      return new Promise((resolve, reject) => {
        api.post(`/FundDisbursement/RepostFundDisbursement?FundDisbursementId=${fundDisbursementId}&Comment=${comment}`, null, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    ApproveRepostFundDisbursement ({ rootState, dispatch }, { fundDisbursementRequeryId, config }) {
      return new Promise((resolve, reject) => {
        api.post(`/FundDisbursement/ApproveRepostFundDisbursement?FundDisbursementRequeryId=${fundDisbursementRequeryId}`, null, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    DisapproveRepostFundDisbursement ({ rootState, dispatch }, { fundDisbursementRequeryId, comment, config }) {
      return new Promise((resolve, reject) => {
        api.post(`/FundDisbursement/DisapproveRepostFundDisbursement?FundDisbursementRequeryId=${fundDisbursementRequeryId}&Comment=${comment}`, null, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    // MERCHANT
    RepostFundDisbursementByMerchant ({ rootState, dispatch }, { fundDisbursementId, comment, config }) {
      return new Promise((resolve, reject) => {
        api.post(`/FundDisbursement/RepostFundDisbursementByMerchant?FundDisbursementId=${fundDisbursementId}&Comment=${comment}`, null, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    ApproveRepostFundDisbursementByMerchant ({ rootState, dispatch }, { fundDisbursementRequeryId, config }) {
      return new Promise((resolve, reject) => {
        api.post(`/FundDisbursement/ApproveRepostFundDisbursementByMerchant?FundDisbursementRequeryId=${fundDisbursementRequeryId}`, null, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    DisapproveRepostFundDisbursementByMerchant ({ rootState, dispatch }, { fundDisbursementRequeryId, comment, config }) {
      return new Promise((resolve, reject) => {
        api.post(`/FundDisbursement/DisapproveRepostFundDisbursementByMerchant?FundDisbursementRequeryId=${fundDisbursementRequeryId}&Comment=${comment}`, null, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    // ----------------------------------------------

    GetPendingFundDisbursement ({ dispatch, rootState }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/FundDisbursement/GetPendingFundDisbursement?SearchValue=${paginationParams.searchValue}&PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetApprovedFundDisbursement ({ dispatch, rootState }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/FundDisbursement/GetApprovedFundDisbursement?SearchValue=${paginationParams.searchValue}&PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetDisapprovedFundDisbursement ({ dispatch, rootState }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/FundDisbursement/GetDisapprovedFundDisbursement?SearchValue=${paginationParams.searchValue}&PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetDeletedFundDisbursement ({ dispatch, rootState }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/FundDisbursement/GetDeletedFundDisbursement?SearchValue=${paginationParams.searchValue}&PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    // -------------------------------------------------------------------------------
    GetFundDisbursementSummary ({ dispatch, rootState }, { fundDisbursementId, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/FundDisbursement/GetFundDisbursementSummary?FundDisbursementId=${fundDisbursementId}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetFundDisbursementBeneficiaries ({ dispatch, rootState }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/FundDisbursement/GetFundDisbursementBeneficiaries?SearchValue=${paginationParams.searchValue}&PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}&FundDisbursementId=${paginationParams.fundDisbursementId}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetFundDisbursementBeneficiariesAll ({ dispatch, rootState }, { fundDisbursementId, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/FundDisbursement/GetFundDisbursementBeneficiariesAll?FundDisbursementId=${fundDisbursementId}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetAwaitingForApprovalRepostFundDisbursement ({ dispatch, rootState }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/FundDisbursement/GetAwaitingForApprovalRepostFundDisbursement?SearchValue=${paginationParams.searchValue}&PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetApprovedRepostFundDisbursement ({ dispatch, rootState }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/FundDisbursement/GetApprovedRepostFundDisbursement?SearchValue=${paginationParams.searchValue}&PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetDisapprovedRepostFundDisbursement ({ dispatch, rootState }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/FundDisbursement/GetDisapprovedRepostFundDisbursement?SearchValue=${paginationParams.searchValue}&PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    }
  }
}
export default fundDisbursement
